import {createContext, useContext, useEffect, useState} from "react";
import {getUserSessionData, printError, printLog, sendRequest} from "../utils/AppUtils";
import {DEF_APP_THEME, Keys, ReqUrls} from "../config/AppConfig";
import {checkNullJson, getBrowserCookie, getJsonValue, isJsonValueTrue, strToJson} from "../../common/fusion-ui/utils/ReactUtils";
import {useLocalStoreData} from "./LocalStoreProvider";

const SubdomainContext = createContext(null);
const TAG = 'SubdomainProvider';

function SubdomainProvider({children}) {
    const {updateLocalStoreField, getLocalStoreField, checkLocalStoreFieldNullJson,} = useLocalStoreData();
    // const mf = ModuleFieldsData[Modules.Company];

//     const DEF_SD_DATA = {
//         [Keys.subdomain_Name]: AppName,
//         [Keys.subdomain_Logo]: SpkLogo,
//         [Keys.theme]: DEF_APP_THEME,
//         [Keys.subdomain_Description]: 'Welcome to the Sanofi Pasteur e-Advocacy and Knowledge – SPeAK initiative: an elite, exclusive community of Indian and global thought leaders. SPeAK is an unique peer to peer collaborative platform which will enable you to connect with leading KOLs and peers anywhere, anytime, to discuss everyday challenges and best practices in management of meningitis.',
//         [Keys.subdomain_ShowAuthPageImage]: true,
//         [Keys.subdomain_LoginImage]: "https://images.unsplash.com/photo-1637825891028-564f672aa42c?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
//         [Keys.subdomain_RequestAccessImage]: "https://images.unsplash.com/photo-1579547621113-e4bb2a19bdd6?q=80&w=1878&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D", // [Keys.subdomain_LoginImage]: "https://cdn.pixabay.com/photo/2024/02/13/17/30/dna-8571480_1280.jpg",
//         // [Keys.subdomain_RequestAccessImage]: "https://cdn.pixabay.com/photo/2023/10/28/05/59/dna-8346570_1280.png",
//         // [Keys.subdomain_RequestAccessImage]: "https://cdn.pixabay.com/photo/2023/08/03/11/48/abstract-8166949_1280.jpg",
//         // [Keys.subdomain_RequestAccessImage]: "https://cdn.pixabay.com/photo/2020/08/09/14/25/business-5475661_1280.jpg",
//         // [Keys.subdomain_RequestAccessImage]: "https://cdn.pixabay.com/photo/2021/05/19/06/13/smartphone-6265047_1280.jpg",
//         // [Keys.subdomain_LoginImage]: "https://images.unsplash.com/photo-1618005198919-d3d4b5a92ead?q=80&w=1974&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
//         // [Keys.subdomain_LoginImage]: "https://images.unsplash.com/photo-1606206873764-fd15e242df52?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
//         // [Keys.subdomain_LoginImage]: "https://images.unsplash.com/photo-1600195077077-7c815f540a3d?q=80&w=1889&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
// // [Keys.subdomain_RequestAccessImage]: "https://images.unsplash.com/photo-1618556450991-2f1af64e8191?q=80&w=1964&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
//         // [Keys.subdomain_LoginImage]: "https://cdn.pixabay.com/photo/2024/02/09/17/06/ai-generated-8563463_1280.jpg",
//         // [Keys.subdomain_LoginImage]: "https://cdn.pixabay.com/photo/2022/06/16/12/19/ai-7265839_1280.jpg",
//         // [Keys.subdomain_LoginImage]: "https://cdn.pixabay.com/photo/2018/05/18/15/30/web-design-3411373_1280.jpg",
//     };//for testing & localhost only

    const [subdomainValidationData, setSubdomainValidationData] = useState({
        isSubdomainValid: false, isSubdomainChecking: false, subdomainCheckMsg: null, redirectUrl: null
    });
    const [subdomainData, setSubdomainData] = useState({});
    const [isDataLoaded, setIsDataLoaded] = useState(false);


    useEffect(() => {
        if (checkNullJson(getUserSessionData())) {
            const sdData = getLocalStoreField(Keys.subdomainData);
            const isSdDataFound = checkNullJson(sdData);
            if (isSdDataFound) {
                let domainPrefs = strToJson(strToJson(getJsonValue(sdData, Keys.subdomainPrefs)));
                const prefsFound = checkNullJson(domainPrefs);
                if (prefsFound) {
                    domainPrefs = {
                        ...domainPrefs,
                        [Keys.subdomain_LoginImage]: getJsonValue(sdData, Keys.subdomain_LoginImage),
                        [Keys.subdomain_RequestAccessImage]: getJsonValue(sdData, Keys.subdomain_RequestAccessImage),
                    }
                }
                setSubdomainData({...sdData, ...domainPrefs});
            }
        }
    }, []);
    const fetchSubdomainData = () => {
        const fun = 'fetchSubdomainData:';
        try {
            // if (!isDataLoaded  && (!subdomainValidationData.isSubdomainValid || (!subdomainValidationData.isSubdomainChecking))) {
            // if (!isDataLoaded && ((!subdomainValidationData.isSubdomainChecking))) {
            const sdData = getLocalStoreField(Keys.subdomainData);
            // const isLocalDataFound = checkLocalStoreFieldNullJson(Keys.subdomainData);
            const isLocalDataFound = checkNullJson(sdData);
            log(fun, 'isLocalDataFound:', isLocalDataFound);

            if (!isDataLoaded && !isLocalDataFound) {
                setIsDataLoaded(true);
                setSubdomainValidationData(prevState => ({
                    ...prevState, isSubdomainChecking: true, subdomainCheckMsg: null
                }));

                const REQ_OPTIONS = {
                    userCreds: getUserSessionData(), [Keys.browserUrl]: window.location.href,
                };
                sendRequest({
                    reqUrl: ReqUrls.fetchSubdomainDataFromAdminDb,
                    reqOptions: REQ_OPTIONS,
                    onFetched: ((fetchedData) => {
                        setIsDataLoaded(true);

                        log(fun, 'sendRequest.fetchedData:', fetchedData);
                        const isSubdomainValid = checkNullJson(fetchedData);
                        const success = isJsonValueTrue(fetchedData, 'success');
                        const message = getJsonValue(fetchedData, 'message');

                        updateLocalStoreField(Keys.subdomainData, fetchedData);
                        setSubdomainData(fetchedData);
                        log(fun, 'isLocalDataFound-false: success:', success, 'message:', message);

                        setSubdomainValidationData(prevState => ({
                            ...prevState, isSubdomainChecking: false, isSubdomainValid: isSubdomainValid,
                        }));
                    }),
                    onError: ((error) => {
                        logErr(fun, error);
                        setIsDataLoaded(false);
                    }),
                });
                // } else {
                //     setSubdomainData(sdData);
                //     setSubdomainValidationData(prevState => ({
                //         ...prevState,
                //         isSubdomainChecking: false,
                //         isSubdomainValid: true,
                //     }));
                //     setIsDataLoaded(false);
                // }
                // } else {
                // setSubdomainValidationData(prevState => ({
                //     ...prevState,
                //     isSubdomainChecking: false,
                //     isSubdomainValid: true,
                //     subdomainCheckMsg: null
                // }));
            }
        } catch (error) {
            setIsDataLoaded(false);
            setSubdomainValidationData(prevState => ({
                ...prevState, isSubdomainChecking: false, isSubdomainValid: false, subdomainCheckMsg: "Couldn't verify subdomain, please refresh page again!",
            }));
            logErr(fun, error);
        }
    }

    const value = {
        subdomainData, ...subdomainValidationData,
        // appTheme: getJsonValue(subdomainData, Keys.theme, DEF_APP_THEME)
        appTheme: getJsonValue(subdomainData, Keys.theme, getBrowserCookie(Keys.theme, DEF_APP_THEME))
        // appTheme: getJsonValue(subdomainData, Keys.theme, getBrowserCookie(Keys.theme, ThemeName.ROYAL_BLUE))
        // appTheme: getJsonValue(subdomainData, Keys.theme, getBrowserCookie(Keys.theme))
    };

    return <SubdomainContext.Provider value={value}>
        {children}
    </SubdomainContext.Provider>

}

function useSubdomainData() {
    // log('useSubdomainData.srcTag:', srcTag);
    return useContext(SubdomainContext);
}


function log(...text) {
    printLog(TAG, ...text);
}

function logErr(...text) {
    printError(TAG, ...text);
}

export {SubdomainProvider, useSubdomainData};
